import { InverseHeader } from '@jouzen/ecom-components/layout';

import LandingPageAccuracy from '@/app/components/LandingPage/LandingPageAccuracy';

import accuracyCards from './data/accuracyCards';

const WhyOuraAccuracy = () => {
  return (
    <section className="relative py-16 md:py-0" data-cy="why-oura-accuracy">
      <InverseHeader enter>
        <LandingPageAccuracy
          accuracyCards={accuracyCards}
          backgroundImage={{
            className: 'object-cover',
            fill: true,
            localizedAlt: 'man_window_alt',
            srcSet: [
              {
                src: 'why-oura/oreo/data-so-accurate',
              },
            ],
          }}
          description="accuracy_description"
          title="accuracy_title"
          className="md:text-sandstone-500"
        />
      </InverseHeader>
    </section>
  );
};

export default WhyOuraAccuracy;
